import { CallReceivedSituations } from '../../../../../../../../src/utils/fuctions/mapSituationCallReceived';

export const callEventStyle = (eventKey) => {
  const event = CallReceivedSituations[eventKey];

  switch (event) {
    case 'entrou_na_fila':
      return {
        name: 'ENTROU NA FILA',
        color: '#5bc0de',
        icon: 'fas fa-sign-in-alt',
        iconColor: 'white'
      };
    case 'transferida':
      return {
        name: 'TRANSFERIDA',
        color: '#e0e0e0',
        icon: 'fas fa-external-link-alt',
        iconColor: '#999999'
      };
    case 'não_atendida':
      return {
        name: 'NÃO ATENDIDA',
        color: '#3674B5',
        icon: 'fas fa-phone-slash',
        iconColor: 'white'
      };
    case 'chamada_desligada':
      return {
        name: 'ENCERRADA',
        color: '#d9534f',
        icon: 'fas fa-user-times',
        iconColor: 'white'
      };
    case 'complete_call':
      return {
        name: 'CHAMADA COMPLETA',
        color: '#5cb85c',
        icon: 'fas fa-check',
        iconColor: 'white'
      };
    case 'abandonada':
      return {
        name: 'ABANDONADA',
        color: '#c9302c',
        icon: 'fas fa-times',
        iconColor: 'white'
      };
    default:
      return {
        name: 'EVENTO DESCONHECIDO',
        color: '#f7f7f7',
        icon: 'fas fa-question',
        iconColor: '#999999'
      };
  }
};
